<template>
  <div class="esp-container">
    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Oftalmología">
      <AyudaOftalmologia />
    </Modal>
	
    <!-- Toolbar -->
    <div class="card mb-3">
      <div class="card-body py-2">
        <div class="d-flex align-items-center gap-3 mb-2 border-bottom pb-2">
          <button type="button" class="tab-modo"
            :class="modoVista==='editar' ? 'tab-modo-active-edit' : 'tab-modo-inactive'"
            :disabled="!editable" @click="modoVista='editar'">
            <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">edit</span>
            Modo Edición
          </button>
          <button type="button" class="tab-modo"
            :class="modoVista==='consultar' ? 'tab-modo-active-view' : 'tab-modo-inactive'"
            @click="modoVista='consultar'">
            <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">pageview</span>
            Modo Consulta
          </button>
          <span v-if="modoVista==='editar'" class="badge bg-warning text-dark ms-1" style="font-size:11px">
            <span class="material-symbols-outlined" style="font-size:12px;vertical-align:middle">brush</span>
            Completa los datos del examen oftalmológico
          </span>
          <span v-else class="badge bg-info text-dark ms-1" style="font-size:11px">Solo lectura</span>
        </div>

        <div class="d-flex align-items-center gap-2 flex-wrap">
          <button v-for="tab in tabs" :key="tab.key" type="button" class="btn btn-sm"
            :class="tabActual===tab.key ? 'btn-primary' : 'btn-outline-secondary'"
            @click="tabActual=tab.key">
            {{ tab.label }}
          </button>
          <div class="ms-auto d-flex gap-2">
            <button type="button" class="btn btn-sm btn-outline-danger"
              :disabled="!editable || modoVista==='consultar'" @click="limpiar">
              <span class="material-symbols-outlined" style="font-size:16px">restart_alt</span> Limpiar
            </button>
            <button type="button" class="btn btn-sm btn-success"
              :disabled="!editable || guardando || modoVista==='consultar'" @click="guardar">
              <span class="material-symbols-outlined" style="font-size:16px">save</span>
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
  <button
    type="button"
    class="btn btn-sm btn-outline-secondary"
    title="Abrir ayuda"
    @click="showModalHelp = true"
    aria-label="Abrir ayuda de oftalmología">
    <span class="material-symbols-outlined" style="font-size:16px">help</span>
  </button>
          </div>
        </div>
      </div>
    </div>

    <!--  TAB: GENERAL  -->
    <div v-show="tabActual==='general'">
      <div class="card mb-3">
        <div class="card-header py-1"><small class="fw-bold">Datos de la consulta</small></div>
        <div class="card-body py-2">
          <div class="row g-2">
            <div class="col-md-3">
              <label class="form-label form-label-sm">Tipo de consulta</label>
              <select class="form-select form-select-sm"
                v-model="consulta.tipoConsulta" :disabled="soloLectura">
                <option value="primera_vez">Primera vez</option>
                <option value="control">Control</option>
                <option value="urgencia">Urgencia</option>
              </select>
            </div>
            <div class="col-md-9">
              <label class="form-label form-label-sm">Motivo de consulta</label>
              <input type="text" class="form-control form-control-sm"
                v-model="consulta.motivoConsulta" :disabled="soloLectura"
                placeholder="Motivo principal..."/>
            </div>
            <div class="col-12">
              <label class="form-label form-label-sm">Antecedentes oftalmológicos</label>
              <textarea class="form-control form-control-sm" rows="2"
                v-model="consulta.antecedentesOft" :disabled="soloLectura"
                placeholder="Cirugías previas, uso de lentes, patologías..."/>
            </div>
          </div>
        </div>
      </div>

      <!-- Síntomas -->
      <div class="card mb-3">
        <div class="card-header py-1"><small class="fw-bold">Síntomas</small></div>
        <div class="card-body py-2">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="sintoma-row">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="chkVB"
                    v-model="consulta.visionBorrosa" :disabled="soloLectura">
                  <label class="form-check-label fw-bold" for="chkVB">Visión borrosa</label>
                </div>
                <input v-if="consulta.visionBorrosa" class="form-control form-control-sm mt-1"
                  v-model="consulta.visionBorrosaDet" :disabled="soloLectura"
                  placeholder="Lejos, cerca, ambos..."/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="sintoma-row">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="chkDO"
                    v-model="consulta.dolorOcular" :disabled="soloLectura">
                  <label class="form-check-label fw-bold" for="chkDO">Dolor ocular</label>
                </div>
                <input v-if="consulta.dolorOcular" class="form-control form-control-sm mt-1"
                  v-model="consulta.dolorOcularDet" :disabled="soloLectura"
                  placeholder="Localización, intensidad..."/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="sintoma-row">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="chkSec"
                    v-model="consulta.secrecion" :disabled="soloLectura">
                  <label class="form-check-label fw-bold" for="chkSec">Secreción</label>
                </div>
                <select v-if="consulta.secrecion"
                  class="form-select form-select-sm mt-1"
                  v-model="consulta.secrecionTipo" :disabled="soloLectura">
                  <option value="">— Tipo —</option>
                  <option value="serosa">Serosa</option>
                  <option value="purulenta">Purulenta</option>
                  <option value="mucosa">Mucosa</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="sintoma-row d-flex flex-wrap gap-3">
                <div class="form-check form-switch" v-for="s in sintomasSimples" :key="s.key">
                  <input class="form-check-input" type="checkbox" :id="'chk'+s.key"
                    v-model="consulta[s.key]" :disabled="soloLectura">
                  <label class="form-check-label fw-bold" :for="'chk'+s.key">{{ s.label }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <label class="form-label form-label-sm">Observación</label>
            <textarea class="form-control form-control-sm" rows="2"
              v-model="consulta.observacion" :disabled="soloLectura"/>
          </div>
        </div>
      </div>

      <!-- Resumen síntomas activos -->
      <div class="card mb-3" v-if="sintomasActivos.length">
        <div class="card-body py-2 d-flex flex-wrap gap-2">
          <span v-for="s in sintomasActivos" :key="s" class="badge rounded-pill bg-danger">{{ s }}</span>
        </div>
      </div>
    </div>

    <!--  TAB: AGUDEZA VISUAL  -->
    <div v-show="tabActual==='agudeza'">
      <div class="card mb-3">
        <div class="card-header py-1 d-flex align-items-center">
          <small class="fw-bold">Agudeza visual</small>
          <button v-if="!soloLectura" type="button"
            class="btn btn-sm btn-outline-primary ms-auto"
            @click="agregarAgudeza">
            <span class="material-symbols-outlined" style="font-size:15px">add</span> Agregar
          </button>
        </div>
        <div class="card-body py-2">
          <div v-if="!agudezasVisuales.length"
            class="text-muted text-center py-3" style="font-size:13px">Sin registros</div>

          <div v-for="(av, idx) in agudezasVisuales" :key="idx" class="examen-card mb-3">
            <div class="examen-header">
              <span class="badge" :class="av.ojo==='OD' ? 'bg-danger' : 'bg-primary'">
                {{ av.ojo==='OD' ? 'Ojo Derecho (OD)' : 'Ojo Izquierdo (OI)' }}
              </span>
              <span class="badge ms-1"
                :class="av.conCorreccion ? 'bg-success' : 'bg-secondary'">
                {{ av.conCorreccion ? 'Con corrección' : 'Sin corrección' }}
              </span>
              <span v-if="av.snellenNum && av.snellenDen"
                class="badge bg-light text-dark border ms-1">
                {{ av.snellenNum }}/{{ av.snellenDen }}
              </span>
              <button v-if="!soloLectura" type="button"
                class="btn btn-sm btn-outline-danger ms-auto py-0"
                @click="agudezasVisuales.splice(idx,1)">
                <span class="material-symbols-outlined" style="font-size:14px">delete</span>
              </button>
            </div>
            <div class="row g-2 mt-1">
              <div class="col-6 col-md-2">
                <label class="form-label form-label-sm">Ojo</label>
                <select class="form-select form-select-sm" v-model="av.ojo" :disabled="soloLectura">
                  <option value="OD">OD</option>
                  <option value="OI">OI</option>
                </select>
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label form-label-sm">Condición</label>
                <select class="form-select form-select-sm"
                  v-model="av.conCorreccion" :disabled="soloLectura">
                  <option :value="false">Sin corrección</option>
                  <option :value="true">Con corrección</option>
                </select>
              </div>
              <div class="col-4 col-md-2">
                <label class="form-label form-label-sm">Snellen num.</label>
                <input type="number" class="form-control form-control-sm"
                  v-model.number="av.snellenNum" :disabled="soloLectura"
                  placeholder="20"/>
              </div>
              <div class="col-4 col-md-2">
                <label class="form-label form-label-sm">Snellen den.</label>
                <input type="number" class="form-control form-control-sm"
                  v-model.number="av.snellenDen" :disabled="soloLectura"
                  @change="calcularDecimalAV(av)"
                  placeholder="200"/>
              </div>
              <div class="col-4 col-md-2">
                <label class="form-label form-label-sm">Decimal</label>
                <input type="number" class="form-control form-control-sm"
                  v-model.number="av.decimalAv" :disabled="soloLectura"
                  step="0.01" placeholder="0.10"/>
              </div>
              <div class="col-12 col-md-1">
                <label class="form-label form-label-sm">LogMAR</label>
                <input type="number" class="form-control form-control-sm"
                  v-model.number="av.logmar" :disabled="soloLectura" step="0.1"/>
              </div>
            </div>
            <div class="mt-1">
              <label class="form-label form-label-sm">Observación</label>
              <input type="text" class="form-control form-control-sm"
                v-model="av.observacion" :disabled="soloLectura"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  TAB: REFRACCIÓN  -->
    <div v-show="tabActual==='refraccion'">
      <div class="card mb-3">
        <div class="card-header py-1 d-flex align-items-center">
          <small class="fw-bold">Refracción / lensometría</small>
          <button v-if="!soloLectura" type="button"
            class="btn btn-sm btn-outline-primary ms-auto"
            @click="agregarRefraccion">
            <span class="material-symbols-outlined" style="font-size:15px">add</span> Agregar
          </button>
        </div>
        <div class="card-body py-2">
          <div v-if="!refracciones.length"
            class="text-muted text-center py-3" style="font-size:13px">Sin registros</div>

          <div v-for="(ref, idx) in refracciones" :key="idx" class="examen-card mb-3">
            <div class="examen-header">
              <span class="badge" :class="ref.ojo==='OD' ? 'bg-danger' : 'bg-primary'">
                {{ ref.ojo==='OD' ? 'OD' : 'OI' }}
              </span>
              <span class="badge bg-secondary ms-1">{{ ref.tipo }}</span>
              <button v-if="!soloLectura" type="button"
                class="btn btn-sm btn-outline-danger ms-auto py-0"
                @click="refracciones.splice(idx,1)">
                <span class="material-symbols-outlined" style="font-size:14px">delete</span>
              </button>
            </div>
            <div class="row g-2 mt-1">
              <div class="col-6 col-md-2">
                <label class="form-label form-label-sm">Ojo</label>
                <select class="form-select form-select-sm" v-model="ref.ojo" :disabled="soloLectura">
                  <option value="OD">OD</option><option value="OI">OI</option>
                </select>
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label form-label-sm">Tipo</label>
                <select class="form-select form-select-sm" v-model="ref.tipo" :disabled="soloLectura">
                  <option value="subjetiva">Subjetiva</option>
                  <option value="objetiva">Objetiva</option>
                  <option value="lensometria">Lensometría</option>
                </select>
              </div>
            </div>
            <!-- Lejos / Cerca -->
            <div class="row g-0 mt-2">
              <div class="col-md-6 pe-md-2">
                <small class="fw-bold d-block mb-1 text-muted" style="font-size:11px">LEJOS</small>
                <div class="row g-2">
                  <div class="col-4">
                    <label class="form-label form-label-sm">Esfera</label>
                    <input type="number" class="form-control form-control-sm"
                      step="0.25" v-model.number="ref.esferaLejos" :disabled="soloLectura"/>
                  </div>
                  <div class="col-4">
                    <label class="form-label form-label-sm">Cilindro</label>
                    <input type="number" class="form-control form-control-sm"
                      step="0.25" v-model.number="ref.cilindroLejos" :disabled="soloLectura"/>
                  </div>
                  <div class="col-4">
                    <label class="form-label form-label-sm">Eje (°)</label>
                    <input type="number" class="form-control form-control-sm"
                      min="0" max="180" v-model.number="ref.ejeLejos" :disabled="soloLectura"/>
                  </div>
                </div>
              </div>
              <div class="col-md-6 ps-md-2 mt-2 mt-md-0">
                <small class="fw-bold d-block mb-1 text-muted" style="font-size:11px">CERCA</small>
                <div class="row g-2">
                  <div class="col-4">
                    <label class="form-label form-label-sm">Esfera</label>
                    <input type="number" class="form-control form-control-sm"
                      step="0.25" v-model.number="ref.esferaCerca" :disabled="soloLectura"/>
                  </div>
                  <div class="col-4">
                    <label class="form-label form-label-sm">Cilindro</label>
                    <input type="number" class="form-control form-control-sm"
                      step="0.25" v-model.number="ref.cilindroCerca" :disabled="soloLectura"/>
                  </div>
                  <div class="col-4">
                    <label class="form-label form-label-sm">Eje (°)</label>
                    <input type="number" class="form-control form-control-sm"
                      min="0" max="180" v-model.number="ref.ejeCerca" :disabled="soloLectura"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-2 mt-1">
              <div class="col-md-2">
                <label class="form-label form-label-sm">Adición (ADD)</label>
                <input type="number" class="form-control form-control-sm"
                  step="0.25" v-model.number="ref.adicion" :disabled="soloLectura"/>
              </div>
            </div>
            <!-- Receta óptica -->
            <div class="receta-box mt-2">
              <small class="fw-bold d-block mb-2" style="font-size:11px">
                <span class="material-symbols-outlined" style="font-size:13px;vertical-align:middle">receipt</span>
                Receta óptica
              </small>
              <div class="row g-2">
                <div class="col-6 col-md-2">
                  <label class="form-label form-label-sm">D.P. (mm)</label>
                  <input type="number" class="form-control form-control-sm"
                    step="0.5" v-model.number="ref.recetaDp" :disabled="soloLectura"/>
                </div>
                <div class="col-6 col-md-3">
                  <label class="form-label form-label-sm">Tipo de lente</label>
                  <select class="form-select form-select-sm"
                    v-model="ref.recetaTipoLente" :disabled="soloLectura">
                    <option value="">—</option>
                    <option value="monofocal">Monofocal</option>
                    <option value="bifocal">Bifocal</option>
                    <option value="progresivo">Progresivo</option>
                    <option value="contacto">Lente de contacto</option>
                  </select>
                </div>
                <div class="col-6 col-md-3">
                  <label class="form-label form-label-sm">Material</label>
                  <select class="form-select form-select-sm"
                    v-model="ref.recetaMaterial" :disabled="soloLectura">
                    <option value="">—</option>
                    <option value="CR39">CR-39</option>
                    <option value="policarbonato">Policarbonato</option>
                    <option value="trivex">Trivex</option>
                    <option value="alto_indice">Alto índice</option>
                  </select>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label form-label-sm">Filtro / tratamiento</label>
                  <select class="form-select form-select-sm"
                    v-model="ref.recetaFiltro" :disabled="soloLectura">
                    <option value="">—</option>
                    <option value="antirreflejo">Antirreflejo</option>
                    <option value="fotocromatico">Fotocromático</option>
                    <option value="bloqueo_azul">Bloqueo luz azul</option>
                    <option value="antirreflejo_azul">Antirreflejo + luz azul</option>
                  </select>
                </div>
                <div class="col-12">
                  <label class="form-label form-label-sm">Observación de receta</label>
                  <input type="text" class="form-control form-control-sm"
                    v-model="ref.recetaObservacion" :disabled="soloLectura"
                    placeholder="Indicaciones adicionales para el óptico..."/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  TAB: BIOMICROSCOPÍA  -->
    <div v-show="tabActual==='biomicroscopia'">
      <div class="card mb-3">
        <div class="card-header py-1 d-flex align-items-center">
          <small class="fw-bold">Biomicroscopía (lámpara de hendidura)</small>
          <button v-if="!soloLectura" type="button"
            class="btn btn-sm btn-outline-primary ms-auto"
            @click="agregarBiomicroscopia">
            <span class="material-symbols-outlined" style="font-size:15px">add</span> Agregar
          </button>
        </div>
        <div class="card-body py-2">
          <div v-if="!biomicroscopias.length"
            class="text-muted text-center py-3" style="font-size:13px">Sin registros</div>

          <div v-for="(bio, idx) in biomicroscopias" :key="idx" class="examen-card mb-3">
            <div class="examen-header">
              <span class="badge" :class="bio.ojo==='OD' ? 'bg-danger' : 'bg-primary'">
                {{ bio.ojo==='OD' ? 'Ojo Derecho (OD)' : 'Ojo Izquierdo (OI)' }}
              </span>
              <button v-if="!soloLectura" type="button"
                class="btn btn-sm btn-outline-danger ms-auto py-0"
                @click="biomicroscopias.splice(idx,1)">
                <span class="material-symbols-outlined" style="font-size:14px">delete</span>
              </button>
            </div>
            <div class="row g-2 mt-1">
              <div class="col-md-2">
                <label class="form-label form-label-sm">Ojo</label>
                <select class="form-select form-select-sm" v-model="bio.ojo" :disabled="soloLectura">
                  <option value="OD">OD</option><option value="OI">OI</option>
                </select>
              </div>
            </div>
            <div class="row g-2 mt-1">
              <div v-for="campo in camposBio" :key="campo.key" class="col-md-6">
                <label class="form-label form-label-sm">{{ campo.label }}</label>
                <input type="text" class="form-control form-control-sm"
                  v-model="bio[campo.key]" :disabled="soloLectura"
                  :placeholder="campo.placeholder"/>
              </div>
              <div class="col-12">
                <label class="form-label form-label-sm">Observación</label>
                <textarea class="form-control form-control-sm" rows="2"
                  v-model="bio.observacion" :disabled="soloLectura"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  TAB: FONDO DE OJO + PIO  -->
    <div v-show="tabActual==='fondo'">
      <div class="card mb-3">
        <div class="card-header py-1 d-flex align-items-center">
          <small class="fw-bold">Fondo de ojo y tonometría</small>
          <button v-if="!soloLectura" type="button"
            class="btn btn-sm btn-outline-primary ms-auto"
            @click="agregarFondo">
            <span class="material-symbols-outlined" style="font-size:15px">add</span> Agregar
          </button>
        </div>
        <div class="card-body py-2">
          <div v-if="!fondosOjo.length"
            class="text-muted text-center py-3" style="font-size:13px">Sin registros</div>

          <div v-for="(fo, idx) in fondosOjo" :key="idx" class="examen-card mb-3">
            <div class="examen-header">
              <span class="badge" :class="fo.ojo==='OD' ? 'bg-danger' : 'bg-primary'">
                {{ fo.ojo==='OD' ? 'Ojo Derecho (OD)' : 'Ojo Izquierdo (OI)' }}
              </span>
              <span v-if="fo.pio" class="badge ms-1"
                :class="fo.pio > 21 ? 'bg-danger' : 'bg-success'">
                PIO: {{ fo.pio }} mmHg {{ fo.pio > 21 ? '⚠ Alta' : '' }}
              </span>
              <button v-if="!soloLectura" type="button"
                class="btn btn-sm btn-outline-danger ms-auto py-0"
                @click="fondosOjo.splice(idx,1)">
                <span class="material-symbols-outlined" style="font-size:14px">delete</span>
              </button>
            </div>

            <!-- Tonometría -->
            <div class="pio-box mt-2 mb-2">
              <small class="fw-bold d-block mb-1" style="font-size:11px">Tonometría</small>
              <div class="row g-2">
                <div class="col-md-2">
                  <label class="form-label form-label-sm">Ojo</label>
                  <select class="form-select form-select-sm" v-model="fo.ojo" :disabled="soloLectura">
                    <option value="OD">OD</option><option value="OI">OI</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label form-label-sm">PIO (mmHg)</label>
                  <input type="number" class="form-control form-control-sm"
                    step="0.1" v-model.number="fo.pio" :disabled="soloLectura"/>
                </div>
                <div class="col-md-3">
                  <label class="form-label form-label-sm">Método</label>
                  <select class="form-select form-select-sm"
                    v-model="fo.metodoPio" :disabled="soloLectura">
                    <option value="">—</option>
                    <option value="aplanacion">Aplanación (Goldmann)</option>
                    <option value="no_contacto">No contacto</option>
                    <option value="icare">iCare</option>
                    <option value="tonopen">Tono-Pen</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label form-label-sm">Hora</label>
                  <input type="time" class="form-control form-control-sm"
                    v-model="fo.horaPio" :disabled="soloLectura"/>
                </div>
              </div>
            </div>

            <!-- Fondo de ojo -->
            <small class="fw-bold d-block mb-1" style="font-size:11px">Fondo de ojo</small>
            <div class="row g-2">
              <div class="col-md-6">
                <label class="form-label form-label-sm">Papila</label>
                <input type="text" class="form-control form-control-sm"
                  v-model="fo.papila" :disabled="soloLectura"
                  placeholder="Bordes, coloración, excavación..."/>
              </div>
              <div class="col-md-2">
                <label class="form-label form-label-sm">C/D ratio</label>
                <input type="number" class="form-control form-control-sm"
                  step="0.1" min="0" max="1"
                  v-model.number="fo.cdRatio" :disabled="soloLectura"
                  placeholder="0.3"/>
              </div>
              <div class="col-md-4">
                <label class="form-label form-label-sm">Mácula</label>
                <input type="text" class="form-control form-control-sm"
                  v-model="fo.macula" :disabled="soloLectura"
                  placeholder="Reflejo foveal, drusas..."/>
              </div>
              <div class="col-md-6">
                <label class="form-label form-label-sm">Vasos</label>
                <input type="text" class="form-control form-control-sm"
                  v-model="fo.vasos" :disabled="soloLectura"
                  placeholder="Relación A/V, cruces, tortuosidad..."/>
              </div>
              <div class="col-md-6">
                <label class="form-label form-label-sm">Retina periférica</label>
                <input type="text" class="form-control form-control-sm"
                  v-model="fo.retinaPeriferia" :disabled="soloLectura"
                  placeholder="Degeneraciones, desgarros..."/>
              </div>
              <div class="col-md-6">
                <label class="form-label form-label-sm">Vítreo</label>
                <input type="text" class="form-control form-control-sm"
                  v-model="fo.vitreo" :disabled="soloLectura"
                  placeholder="Claro, opacidades, miodesopsias..."/>
              </div>
              <div class="col-12">
                <label class="form-label form-label-sm">Observación</label>
                <textarea class="form-control form-control-sm" rows="2"
                  v-model="fo.observacion" :disabled="soloLectura"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AyudaOftalmologia from '@/views/ayuda/AyudaOftalmologia.vue'
import api from '@/services/api'
import swal2 from 'sweetalert2'

const consultaVacia = () => ({
  idOftaConsulta: null, tipoConsulta: 'primera_vez',
  motivoConsulta: '', antecedentesOft: '',
  visionBorrosa: false, visionBorrosaDet: '',
  dolorOcular: false, dolorOcularDet: '',
  fotofobia: false, diplopia: false,
  secrecion: false, secrecionTipo: '',
  ojoRojo: false, perdidaVision: false,
  observacion: ''
})
const agudezaVacia   = () => ({ ojo: 'OD', conCorreccion: false,
  snellenNum: 20, snellenDen: null, decimalAv: null, escala: 'snellen', logmar: null, observacion: '' })
const refraccionVacia = () => ({ ojo: 'OD', tipo: 'subjetiva',
  esferaLejos: null, cilindroLejos: null, ejeLejos: null,
  esferaCerca: null, cilindroCerca: null, ejeCerca: null,
  adicion: null, recetaDp: null, recetaTipoLente: '',
  recetaMaterial: '', recetaFiltro: '', recetaObservacion: '' })
const bioVacia = () => ({ ojo: 'OD', parpados: '', pestanas: '',
  conjuntivaTarsal: '', conjuntivaBulbar: '', cornea: '',
  camaraAnterior: '', iris: '', cristalino: '', vitreoAnterior: '', observacion: '' })
const fondoVacio = () => ({ ojo: 'OD', pio: null, metodoPio: '',
  horaPio: '', papila: '', cdRatio: null, macula: '',
  vasos: '', retinaPeriferia: '', vitreo: '', observacion: '' })

export default {
  name: 'OftalmologiaForm',  
  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, default: '' }
  },
components: { AyudaOftalmologia },
  data() {
    return {
      tabActual: 'general',
      modoVista: 'editar',
      tabs: [
        { key: 'general',        label: 'General' },
        { key: 'agudeza',        label: 'Agudeza visual' },
        { key: 'refraccion',     label: 'Refracción' },
        { key: 'biomicroscopia', label: 'Biomicroscopía' },
        { key: 'fondo',          label: 'Fondo / PIO' }
      ],
      sintomasSimples: [
        { key: 'fotofobia',    label: 'Fotofobia' },
        { key: 'diplopia',     label: 'Diplopía' },
        { key: 'ojoRojo',      label: 'Ojo rojo' },
        { key: 'perdidaVision', label: 'Pérdida de visión' }
      ],
      camposBio: [
        { key: 'parpados',          label: 'Párpados',           placeholder: 'Normal, ptosis, blefaritis...' },
        { key: 'pestanas',          label: 'Pestañas',           placeholder: 'Triquiasis, madarosis...' },
        { key: 'conjuntivaTarsal',  label: 'Conjuntiva tarsal',  placeholder: 'Clara, papilas, folículos...' },
        { key: 'conjuntivaBulbar',  label: 'Conjuntiva bulbar',  placeholder: 'Clara, inyección, hemorragia...' },
        { key: 'cornea',            label: 'Córnea',             placeholder: 'Clara, opacidades, úlceras...' },
        { key: 'camaraAnterior',    label: 'Cámara anterior',    placeholder: 'Profunda, media, estrecha...' },
        { key: 'iris',              label: 'Iris',               placeholder: 'Normal, iridodonesis...' },
        { key: 'cristalino',        label: 'Cristalino',         placeholder: 'Claro, opacidad nuclear...' },
        { key: 'vitreoAnterior',    label: 'Vítreo anterior',    placeholder: 'Claro, opacidades...' }
      ],
      consulta:          consultaVacia(),
      agudezasVisuales:  [],
      refracciones:      [],
      biomicroscopias:   [],
      fondosOjo:         [],
      guardando: false,
      showModalHelp: false,
    }
  },
  computed: {
    editable() {
      return this.p_estadoAtencion === 'PENDIENTE' ||
             this.p_estadoAtencion === 'PROCESO'
    },
    soloLectura() {
      return !this.editable || this.modoVista === 'consultar'
    },
    sintomasActivos() {
      const map = {
        visionBorrosa: 'Visión borrosa', dolorOcular: 'Dolor ocular',
        fotofobia: 'Fotofobia', diplopia: 'Diplopía',
        secrecion: 'Secreción', ojoRojo: 'Ojo rojo',
        perdidaVision: 'Pérdida de visión'
      }
      return Object.entries(map)
        .filter(([k]) => this.consulta[k])
        .map(([, v]) => v)
    }
  },
  mounted() {
    if (!this.editable) this.modoVista = 'consultar'
    this.cargar()
  },
  methods: {
    async cargar() {
      try {
        const { data } = await api.get(`/oftalmologia/${this.p_idAtencion}`)
        if (data.consulta) this.consulta = { ...consultaVacia(), ...data.consulta }
        this.agudezasVisuales = data.agudezasVisuales  || []
        this.refracciones     = data.refracciones      || []
        this.biomicroscopias  = data.biomicroscopias   || []
        this.fondosOjo        = data.fondosOjo         || []
      } catch (e) {
        if (e.response?.status !== 404) console.error('Error al cargar oftalmología:', e)
      }
    },
    async guardar() {
      this.guardando = true
      try {
        const idUsuario = sessionStorage.getItem('idUsuario') || 1
        const payload = {
          idAtencion:       this.p_idAtencion,
          consulta:         this.consulta,
          agudezasVisuales: this.agudezasVisuales,
          refracciones:     this.refracciones,
          biomicroscopias:  this.biomicroscopias,
          fondosOjo:        this.fondosOjo
        }
        await api.post(`/oftalmologia?idUsuario=${idUsuario}`, payload)
        swal2.fire({ title: '¡Éxito!', text: 'Datos oftalmológicos guardados.', icon: 'success', confirmButtonText: 'Ok' })
      } catch (e) {
        swal2.fire({ title: 'Error', text: 'No se pudo guardar.', icon: 'error', confirmButtonText: 'Ok' })
        console.error(e)
      } finally {
        this.guardando = false
      }
    },
    limpiar() {
      this.consulta         = consultaVacia()
      this.agudezasVisuales = []
      this.refracciones     = []
      this.biomicroscopias  = []
      this.fondosOjo        = []
    },
    calcularDecimalAV(av) {
      if (av.snellenNum && av.snellenDen && av.snellenDen !== 0) {
        av.decimalAv = Math.round((av.snellenNum / av.snellenDen) * 100) / 100
      }
    },
    agregarAgudeza()        { this.agudezasVisuales.push(agudezaVacia()) },
    agregarRefraccion()     { this.refracciones.push(refraccionVacia()) },
    agregarBiomicroscopia() { this.biomicroscopias.push(bioVacia()) },
    agregarFondo()          { this.fondosOjo.push(fondoVacio()) }
  }
}
</script>

<style src="@/assets/css/listaRegistros.css" scoped></style>
<style src="@/assets/css/especialidades.css"></style>